import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import SharedSidebar from "../shared/SharedSidebar";
import AdminMain from "./AdminMain";

const SIDEBAR_WIDTH = "250px";

const DashboardAdminCombined = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();
  const isDashboardRoute = location.pathname === "/dashboard-admin";

  return (
    <Box minH="100vh">
      {/* Desktop Sidebar */}
      <Box
        display={{ base: "none", md: "block" }}
        position="fixed"
        top={0}
        left={0}
        w={SIDEBAR_WIDTH}
        h="100vh"
        zIndex={1000}
      >
        <SharedSidebar variant="desktop" role="admin" />
      </Box>

      {/* Mobile Sidebar */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
        <DrawerOverlay />
        <DrawerContent p={0} overflow="hidden">
          <Box
            w="250px"
            h="100vh"
            overflowY="auto"
            bg="white"
          >
            <SharedSidebar onNavigate={onClose} variant="mobile" role="admin" />
          </Box>
        </DrawerContent>
      </Drawer>

      {/* Main Content */}
      <AdminMain
        SIDEBAR_WIDTH={SIDEBAR_WIDTH}
        isDashboardRoute={isDashboardRoute}
        onOpen={onOpen} // <-- This is correct!
      />
    </Box>
  );
};

export default DashboardAdminCombined;
